module.exports = __webpack_public_path__ + "static/AngelaHe11-f9643e7f0ea4b8f1557614a7259f1635.webp";